import React, { Component } from "react";
import { observer } from "mobx-react";
import { send_vo_cs } from "http/DetailConn"
import {
    fn_closeDetailMemoView,
    fn_updateDetailMemo,
    fn_vocsDetail, fn_setAgreeFlag, fn_getAgreeFlag
} from "function/FnBodyDetail";


@observer
class VoCsAgreeView extends Component {
    constructor(props) {
        super(props);
        this.inputFocus = React.createRef();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        //this.inputFocus.current.focus();
    }

    render() {

        const { rootStore } = this.props;
        const layerStore = rootStore.layerStore;

        return (
            <div className={"layer_comm layer_common_type " + (layerStore.getLayerCsAgreeView ? ' layer_open' : '')}>
                <div className="bg"></div>
                <div className="layer_content privacy" id="cs_container">
                    <div className="article_common_types">
                        <div className="section_tit_comms">
                            <h1>개인정보 처리방침</h1>
                        </div>
                        <div className="section_textarea privacy">
                            <div className="scroll" id="agreeScroll">
                                <div className="inner">
                                    <p>안녕하세요. 오케이포스입니다.
                                        <br /><br />
                                        배달매니저 문의 접수 및 고충 해결을 위한 개인정보 수집 및 이용 동의가 필요합니다.
                                        <br /><br />
                                        1. 수집 항목
                                        <br />
                                        ⦁ 연락처, 문의내용
                                        <br /><br />
                                        2.  이용 목적
                                        <br />
                                        ⦁ 문의 회신 및 문제 해결을 위한 서비스
                                        <br />&nbsp;&nbsp; 이용기록 조회
                                        <br /><br />
                                        3.  보유 기간
                                        <br />
                                        ⦁ 이용 목적 달성 시까지
                                        <br /><br />
                                        정보 제공자는 위 개인정보 수집을 거부할 권리가 있으나, 거부 시 배달매니저 문의 접수 및 민원 처리가 불가함을 알려드립니다.
                                    </p>
                                </div>
                            </div>
                            <button id="cs_button" type="button" onClick={event => {
                                layerStore.setLayerCsAgreeView(false);
                                document.getElementById("agreeScroll").scrollTo(0, 0);
                            }} >확인</button>
                        </div>
                        <div className="btn_close btn_close_comm">
                            <button
                                onClick={event => { layerStore.setLayerCsAgreeView(false); }}
                            ><span>닫기</span></button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default VoCsAgreeView;